import {connect} from "react-redux";
import Update from "./Update.jsx";
import {updateAction} from "./lastUpdatedActions";

const mapStateToProps = (state) => {
    return {
        ...state.lastUpdated
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onUpdate: () => dispatch(updateAction()),
    }
};

const UpdatePanelContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Update);

export default UpdatePanelContainer